import axios from "axios";

// Fetch Data from API
export const fetchDataFromApi = async (url: string, params?: Record<string, any>): Promise<any> => {
    const tokensString = localStorage.getItem('authTokens');
    let authToken: string | null = null;

    if (tokensString) {
        try {
            const parsedTokens = JSON.parse(tokensString);
            authToken = parsedTokens?.access || null; // Use the access token
        } catch (error) {
            console.error("Failed to parse auth tokens:", error);
            return { error: "Invalid auth tokens format" };
        }
    }

    // Prepare authorization header with the access token
    const authorizationHeader = authToken ? `Bearer ${authToken}` : '';

    try {
        const { data } = await axios.get(url, {
            headers: {
                Authorization: authorizationHeader, // Use the refresh token if available
                'Content-Type': 'application/json',

            },
            params,
        });
        return data;
    } catch (error) {
        console.error("Error fetching data from API:", error);
        return error;
    }
}
// Post Data to The server
export const postDataToTheServer = async (url: string, params: Record<string, any>): Promise<any> => {
    const tokensString = localStorage.getItem('authTokens');
    let authToken: string | null = null;

    if (tokensString) {
        try {
            const parsedTokens = JSON.parse(tokensString);
            authToken = parsedTokens?.access || null; // Use the access token
        } catch (error) {
            console.error("Failed to parse auth tokens:", error);
            return { error: "Invalid auth tokens format" };
        }
    }

    // Prepare authorization header with the access token
    const authorizationHeader = authToken ? `Bearer ${authToken}` : '';
    try {
        const { data } = await axios.post(url, params, {
            headers: {
                Authorization: authorizationHeader,
                'Content-Type': 'multipart/form-data',
            },
        });
        return data;
    } catch (error) {
        return error;
    }
}
export const postJsonDataToTheServer = async (url: string, params: Record<string, any>): Promise<any> => {
    const tokensString = localStorage.getItem('authTokens');
    let authToken: string | null = null;

    if (tokensString) {
        try {
            const parsedTokens = JSON.parse(tokensString);
            authToken = parsedTokens?.access || null; // Use the access token
        } catch (error) {
            console.error("Failed to parse auth tokens:", error);
            return { error: "Invalid auth tokens format" };
        }
    }

    // Prepare authorization header with the access token
    const authorizationHeader = authToken ? `Bearer ${authToken}` : '';
    try {
        const { data } = await axios.post(url, params, {
            headers: {
                Authorization: authorizationHeader,
                'Content-Type': 'application/json',
            },
        });
        return data;
    } catch (error) {
        return error;
    }
}
export const putDataToTheServer = async (url: string, params: Record<string, any>): Promise<any> => {
    const tokensString = localStorage.getItem('authTokens');
    let authToken: string | null = null;

    if (tokensString) {
        try {
            const parsedTokens = JSON.parse(tokensString);
            authToken = parsedTokens?.access || null; // Use the access token
        } catch (error) {
            console.error("Failed to parse auth tokens:", error);
            return { error: "Invalid auth tokens format" };
        }
    }

    // Prepare authorization header with the access token
    const authorizationHeader = authToken ? `Bearer ${authToken}` : '';
    try {
        const { data } = await axios.put(url, params, {
            headers: {
                Authorization: authorizationHeader,
                'Content-Type': 'multipart/form-data',
            }, params,
        })
        return data;
    } catch (error) {
        return error;
    }
}
export const patchDataToTheServer = async (url: string, params: Record<string, any>): Promise<any> => {
    // Retrieve auth tokens from localStorage
    const tokensString = localStorage.getItem('authTokens');
    let authToken: string | null = null;

    if (tokensString) {
        try {
            const parsedTokens = JSON.parse(tokensString);
            authToken = parsedTokens?.access || null; // Use the access token
        } catch (error) {
            console.error("Failed to parse auth tokens:", error);
            return { error: "Invalid auth tokens format" };
        }
    }

    // Prepare authorization header with the access token
    const authorizationHeader = authToken ? `Bearer ${authToken}` : '';

    try {
        // Perform the PATCH request with proper headers and data
        const { data } = await axios.patch(url, params, {
            headers: {
                Authorization: authorizationHeader,
                'Content-Type': 'application/json', // Changed to application/json for better handling of JSON data
            },
        });

        return data; // Return the response data
    } catch (error:any) {
        console.error('Error during the PATCH request:', error);
        return { error: error.response ? error.response.data : error.message }; // Handle errors properly
    }
};
// const response = await axios.patch(AppURL.FrontOfficeURL+"front/customer/sadhiyar/no/update/view/", {
//     reordered_member_sn: reorderedData,
// });